import React, { useState } from "react";
import axiosClient from "../../api/axiosClient";

function AddLocation({ tenants, onClose, existing }) {
  const [form, setForm] = useState(
    existing || {
      tenant_id: "",
      name: "",
      code: "",
      address: "",
      city: "",
      state: "",
      country: "",
    }
  );

  const [loading, setLoading] = useState(false);
  const isEdit = !!existing;

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (isEdit) {
        await axiosClient.put(`/tenant/api/locations/${existing.id}`, form);
        alert("✅ Location updated successfully");
      } else {
        await axiosClient.post("/tenant/api/locations/create", form);
        alert("✅ Location created successfully");
      }
      onClose();
    } catch (err) {
      console.error("Error saving location:", err);
      alert("❌ Failed to save location. Please check your input.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Modal Overlay */}
      <div
        className="modal-backdrop fade show"
        onClick={onClose}
        style={{ zIndex: 1040 }}
      ></div>

      {/* Modal Window */}
      <div
        className="modal fade show d-block"
        tabIndex="-1"
        role="dialog"
        style={{ zIndex: 1050 }}
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content shadow-lg border-0 rounded-4">
            {/* Header */}
            <div
              className="modal-header text-white"
              style={{
                background: "linear-gradient(45deg, #007bff, #0056b3)",
                borderTopLeftRadius: "0.5rem",
                borderTopRightRadius: "0.5rem",
              }}
            >
              <h5 className="modal-title">
                {isEdit ? "✏️ Edit Location" : "➕ Add Location"}
              </h5>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>

            {/* Body */}
            <div className="modal-body">
              <form onSubmit={handleSubmit}>
                {/* Tenant */}
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">Tenant</label>
                    <select
                      name="tenant_id"
                      className="form-select"
                      value={form.tenant_id}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Tenant</option>
                      {tenants.map((t) => (
                        <option key={t.id} value={t.id}>
                          {t.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">Location Code</label>
                    <input
                      type="text"
                      name="code"
                      className="form-control"
                      value={form.code}
                      onChange={handleChange}
                      required
                      placeholder="Enter unique code"
                    />
                  </div>
                </div>

                {/* Name & Address */}
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">Location Name</label>
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      value={form.name}
                      onChange={handleChange}
                      required
                      placeholder="Enter location name"
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">Address</label>
                    <input
                      type="text"
                      name="address"
                      className="form-control"
                      value={form.address}
                      onChange={handleChange}
                      placeholder="Enter address"
                    />
                  </div>
                </div>

                {/* City, State, Country */}
                <div className="row mb-3">
                  <div className="col-md-4">
                    <label className="form-label fw-semibold">City</label>
                    <input
                      type="text"
                      name="city"
                      className="form-control"
                      value={form.city}
                      onChange={handleChange}
                      placeholder="Enter city"
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label fw-semibold">State</label>
                    <input
                      type="text"
                      name="state"
                      className="form-control"
                      value={form.state}
                      onChange={handleChange}
                      placeholder="Enter state"
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label fw-semibold">Country</label>
                    <input
                      type="text"
                      name="country"
                      className="form-control"
                      value={form.country}
                      onChange={handleChange}
                      placeholder="Enter country"
                    />
                  </div>
                </div>

                {/* Footer */}
                <div className="text-end">
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    onClick={onClose}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                    style={{
                      background: "linear-gradient(45deg, #007bff, #0056b3)",
                      border: "none",
                    }}
                  >
                    {loading
                      ? "Saving..."
                      : isEdit
                      ? "Update Location"
                      : "Save Location"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddLocation;
